
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from "@/components/ui/card";
import { Calendar, DollarSign, Package, User } from "lucide-react";
import { Carrier } from "@/api/broker/getCarriers";
import { useQuery } from "@tanstack/react-query";
import {
  getCarrierLoadHistory,
  Load,
} from "@/api/broker/getCarrierLoadHistory";
import { Badge } from "@/components/ui/badge";
import { CarrierLoadHistorySkeleton } from "./skeletons";

type Props = {
  selectedCarrier: Carrier;
};

export const CarrierLoadHistory = ({ selectedCarrier }: Props) => {
  const { data: loads, isLoading } = useQuery({
    queryKey: ["loads", "carrierLoad", selectedCarrier?.id],
    queryFn: () => getCarrierLoadHistory({ carrierId: selectedCarrier.id }),
    enabled: !!selectedCarrier?.id,
  });
  console.log(loads);

  if (!loads || loads.length === 0) {
    return (
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Package className="h-5 w-5" />
            Load History
          </CardTitle>
          <CardDescription>
            No load history available for this carrier.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  if (isLoading) {
    return (
      <CarrierLoadHistorySkeleton/>
    );
  }

  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="h-5 w-5" />
          Load History
        </CardTitle>
        <CardDescription>
          Complete history of loads completed by this carrier
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 h-[calc(60vh-160px)] overflow-y-auto">
          {loads?.map((load) => (
            <div
              key={load.loadId}
              className="p-4 border rounded-lg hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="font-medium text-lg">{load.loadName}</div>
                  <div className="text-gray-600 mt-1">
                    {load.pickupLocation} to {load.deliveryLocation}
                  </div>
                  <div className="flex items-center gap-4 mt-2 text-sm text-gray-500">
                    <span className="flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      {load.pickupDate?.toLocaleString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      })}{" "}
                      -{" "}
                      {load.deliveryDate?.toLocaleString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      })}
                    </span>
                    <span className="flex items-center gap-1">
                      <User className="h-3 w-3" />
                      {load.driverName}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  
                  <Badge
                    variant="default"
                    className="bg-green-100 text-green-800 mt-1"
                  >
                    {load.status}
                  </Badge>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
